import React from 'react'
import { capitalizeIfLower } from '@btime/helpers'
import { useTranslation } from 'react-i18next'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import ChecklistSelect from '../../../../containers/checklists/select/ChecklistSelect'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import ListCounter from '../../../../components/helpers/ListCounter'
import Text from '../../../../packages/kiti/components/presentation/Text'
import { useDynamicServiceOrder } from '../_load/DynamicServiceOrdersLoader'
import { useRowsActions } from './_actions/rowsActions'
import EditableDynamicServiceOrders from '../../../../containers/dynamicServiceOrders/EditableDynamicServiceOrders'

const DynamicServiceOrdersTable = () => {
  const { t } = useTranslation('listDynamicServiceOrders')
  const dynamicServiceOrder = useDynamicServiceOrder()

  const columns = [
    {
      label: t('name'),
      headerSideContent: (
        <>
          <ListCounter
            client={serviceOrdersClient}
            entity="dynamicServiceOrders"
            filterName="DynamicServiceOrderFilter"
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      flex: 4,
      render: (value, record) => (
        <EditableDynamicServiceOrders record={record} field="name">
          <Text color="dark1" bold>
            {value}
          </Text>
        </EditableDynamicServiceOrders>
      ),
      sortIndex: 'NAME'
    },

    {
      label: t('checklist'),
      dataIndex: ['checklist', 'name'],
      render: (value, record) => (
        <EditableDynamicServiceOrders
          record={record}
          field="checklist"
          Input={ChecklistSelect}
          filter={{ usages: ['serviceOrder'], includeDisabled: false }}
        >
          {value ? <Text>{capitalizeIfLower(value)}</Text> : <Text>-</Text>}
        </EditableDynamicServiceOrders>
      ),
      sortIndex: 'CHECKLIST_NAME',
      flex: 3
    },

    {
      label: t('place'),
      dataIndex: ['place', 'name'],
      render: value => <>{value ? <Text>{capitalizeIfLower(value)}</Text> : <Text color="light5">-</Text>}</>,
      sortIndex: 'PLACE_NAME',
      flex: 2
    },

    {
      label: t('actions'),
      flex: 1,
      render: useRowActionsColumn(useRowsActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={dynamicServiceOrder} inPanel size="medium" />
}

export default DynamicServiceOrdersTable
